import { Autocomplete, TextField, Tooltip } from 'components/mui';
import { POST_LOGIN_APP_ID } from 'containers/pages/users/constants';
import { array, func, object } from 'prop-types';
import { useEffect, useState } from 'react';

/**
 * @component PostLoginAppSelector
 * @param {Object} props
 * @param {object} props.user
 * @param {array} props.options
 * @param {function} props.handleForm
 * @returns {JSX.Element}
 */
function PostLoginAppSelector({ user, options, handleForm }) {
	const [tabs, setTabs] = useState([...options]);
	const [selectedId, setSelectedId] = useState('');

	useEffect(() => {
		setTabs([...options]);
		setSelectedId(user[POST_LOGIN_APP_ID] || '');
	}, [options, user]);

	const onChange = (event, newValue) => {
		const newId = newValue ? newValue.id : '';
		setSelectedId(newId);
		handleForm({ target: { name: POST_LOGIN_APP_ID, value: newId } });
	};

	return (
		<Autocomplete
			value={tabs.find((option) => option.id === selectedId) || null}
			options={tabs}
			getOptionLabel={(option) => option.name || ''}
			isOptionEqualToValue={(option, value) => option.id === value.id}
			getOptionKey={(option) => option.id}
			onChange={onChange}
			renderInput={(params) => (
				<Tooltip title="This is the app that the user will see first when they log in." arrow>
				<TextField
					{...params}
					variant="outlined"
					label="Post Login App"
					InputLabelProps={{ shrink: true }}
				/>
				</Tooltip>
			)}
		/>
	);
}

PostLoginAppSelector.propTypes = {
	user: object,
	options: array,
	handleForm: func,
};

export default PostLoginAppSelector;
